export const Permission = {
    NONE: 0,
    READ: 1,
    WRITE: 2
}

export class Permit {

    map = new Map();

    static write(...roles){
        return new Permit().write(...roles);
    }
    static read(...roles){
        return new Permit().read(...roles);
    }
    write(...roles){
        for (let role of roles) this.map.set(role, Permission.WRITE);
        return this;
    }
    read(...roles){
        for (let role of roles) this.map.set(role, Permission.READ);
        return this;
    }
    get(role){
        return this.map.get(role) ?? Permission.NONE;
    }
}